import * as accounting from 'accounting';

export function formatCurrency(value: number | string): string {
    return accounting.formatMoney(value);
}
export function formatCreditCurrencyForPayments(value: number, symbol?: string): string {
    if (value !== undefined) {
        const convertedVal = Math.abs(value);
        return accounting.formatMoney(convertedVal, symbol);
    } else {
        return '-'
    }
}
export function formatCreditCurrency(value: number, symbol?: string): string {
    const convertedVal = Math.abs(value);
    return accounting.formatMoney(convertedVal, symbol);
}
export function formatNegativeCreditCurrency(value: string): string {
    const floatAmountValue = parseFloat(value);
    const formattedAmountValue = formatCreditCurrency(floatAmountValue, '');
    const negativeFormattedValue = (Math.sign(floatAmountValue) === -1) ?
        '-' + formattedAmountValue : formattedAmountValue;
    return negativeFormattedValue;
}

export function formatNegativeCurrency(value: number): string {
    const convertedVal = Math.abs(value);
    return value < 0 ? accounting.formatMoney(convertedVal) + ' Cr' : accounting.formatMoney(value);
}

export function formatNegativeCurrencyWithCreditAndDebit(value: number): string {
    const convertedVal = Math.abs(value);
    return value < 0 ? accounting.formatMoney(convertedVal) + ' Cr' :
        (value > 0 ? accounting.formatMoney(convertedVal) + ' Dr' : accounting.formatMoney(value));
}

export function getDecimalPointSymbol(): string {
    return accounting.settings.currency.decimal;
}

// If value is 1920.65, this function will return $1,920
export function formatDollarPortion(value: number = 0): string {
    const dollarPortion = Math.trunc(value);
    const formattedValue = accounting.formatMoney(
        dollarPortion,
        accounting.settings.currency.symbol,
        0);

    return formattedValue;
}

// If value is 1920, this function will return 00
export function extractCentValue(value: number): string {
    const formattedValue = formatCurrency(value);
    if (value < 0) {
        return formattedValue.substr(
            formattedValue.indexOf(accounting.settings.currency.decimal) + 1,
            accounting.settings.currency.precision
        ) + ' Cr';
    }
    return formattedValue.substr(
        formattedValue.indexOf(accounting.settings.currency.decimal) + 1,
        accounting.settings.currency.precision
    );
}
